import React, { useState } from 'react';
import axios from 'axios';
import './css/ForgotPassword.css'; // optional for styling

const API_BASE = '';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage('');
    setError('');

    try {
      const response = await axios.post(`${API_BASE}/api/forgot-password`, { email });
      setStatusMessage(response.data.message || 'Reset link sent to your email.');
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.message || 'Error sending reset email.';
      setError(msg);
    }
  };

  return (
    <div className="forgot-password-container">
      <h2>Forgot Password</h2>
      <form onSubmit={handleSubmit} className="forgot-password-form">
        <input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Send Reset Link</button>
      </form>

      {statusMessage && <p className="success-message">{statusMessage}</p>}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default ForgotPassword;

